import { PropsWithChildren } from 'react'
import { useRouter } from 'next/navigation'

type Props = PropsWithChildren & {
  href: string
  startTransition: (cb: () => void) => void
}

const TransitionLink = ({ href, children, startTransition }: Props): JSX.Element => {
  const router = useRouter()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    startTransition(() => {
      router.push(href)
    })
  }

  return (
    <a href={href} onClick={handleClick} style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 16 }}>
      {children}
    </a>
  )
}

export default TransitionLink
